import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressionOverview = ({ progressionData }) => {
  const getStatusColor = (percentage) => {
    if (percentage === 100) return 'var(--color-success)';
    if (percentage >= 50) return 'var(--color-warning)';
    return 'var(--color-error)';
  };

  const getStatusIcon = (percentage) => {
    if (percentage === 100) return 'CheckCircle2';
    if (percentage >= 50) return 'Clock';
    return 'Circle';
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 border border-border">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold">
          Expansion Progression
        </h2>
        <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-3 md:space-y-4 lg:space-y-5">
        {progressionData?.map((area, index) => (
          <div key={index} className="space-y-2 md:space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 md:gap-3">
                <Icon 
                  name={getStatusIcon(area?.completion)} 
                  size={18}
                  color={getStatusColor(area?.completion)}
                />
                <div>
                  <h3 className="text-sm md:text-base lg:text-lg font-medium">
                    {area?.name}
                  </h3>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    {area?.completed} of {area?.total} completed
                  </p>
                </div>
              </div>
              <span className="text-sm md:text-base font-semibold whitespace-nowrap">
                {area?.completion}%
              </span>
            </div>

            <div className="w-full h-2 md:h-2.5 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full transition-all duration-500"
                style={{ 
                  width: `${area?.completion}%`,
                  backgroundColor: getStatusColor(area?.completion)
                }}
              />
            </div>

            {area?.lastUpdate && (
              <p className="text-xs text-muted-foreground">
                Last updated: {new Date(area.lastUpdate)?.toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressionOverview;